<div class="mainBody">
     <div class="loader" *ngIf="bodySpinner"></div>
    <div class="container-fluid loginContainer">
        <div class="col-md-12 mt-1">
            <!-- <img src="../../../assets/images/CanString AI logo.svg" class="CanString-AI-logo"> -->
                <img style="width:50px;" src="../../../../assets/images/5_image.jpg" class="CanString-AI-logo align-items-center">
                         <span style="
    padding: 10px;
    font-size: 1.3rem;
">AI Analytics</span>
        </div>
        <div class="row mt-4">
            <div class="col-md-12 d-flex">
                <div class="col-md-12">
                    <img src="../../../assets/images/cs-analytics-ban.svg" class="backImageClass">
                   
                </div> 
               
            </div>
        </div>
       
    </div>
</div>